import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { refresh } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match ? match[1] : null;
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        // Owner login from the Coming Soon page lands on the homepage preview.
        const after = sessionStorage.getItem("atelier_after_login");
        sessionStorage.removeItem("atelier_after_login");
        const target = after || (window.location.pathname === "/" ? "/" : "/dashboard");
        await api.post("/auth/session", { session_id: sid }, { timeout: 20000 });
        window.history.replaceState(null, "", target);
        await refresh();
        navigate(target, { replace: true });
      } catch (e) {
        if (e?.response?.status === 403) sessionStorage.setItem("atelier_owner_denied", "1");
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-xs tracking-[0.3em] uppercase text-neutral-500" data-testid="auth-callback-loader">
        Signing you in
      </div>
    </div>
  );
}
